import React, { useState, FormEvent, useEffect } from "react";
//import logo from '../../img/logo.svg';

import pigzLogo from "../../img/pigz.svg";
import orangeLabLogo from "../../img/orange.svg";
import iconUser from "../../img/icon-user.svg";
import iconLock from "../../img/icon-lock.svg";
//import ReCAPTCHA from 'react-google-recaptcha';

//import './login.css';
import "./app.css";
import { useHistory } from "react-router-dom";
import loadingGif from "../../img/loading-gif.gif";

//import loadingGif from '../../../img/loading-gif.gif';

import { ReCaptcha } from "react-recaptcha-v3";

import Recaptcha from "./Recaptcha";
import api from "../../services/api";
import { X_FOWARD_HOST } from "../../utils/env";
import axios from "axios";
/*import moment from 'moment';
import momentTZ from 'moment-timezone';*/

//import api from '../../services/api';

//https://reactgo.com/react-set-cookie/#:~:text=To%20set%20a%20cookie%2C%20we,have%20created%20in%20your%20app.

const TWO_MINUTES = 1000 * 2 * 60;

function Login() {
  //const { isReady } = this.state;
  //const dotenv = require('dotenv');

  const [isReady] = useState(false);

  const [loading, setLoading] = useState(false);

  const [usuario, setUsuario] = useState("");
  const [senha, setSenha] = useState("");

  const [loadingCaptcha, setLoadingCaptcha] = useState(true);

  const [googleRecaptcha, setGoogleRecaptcha] = useState<string | undefined>(
    undefined
  );

  const [captcha, setCaptcha] = useState<ReCaptcha>();

  const [loginComMatricula, setLoginComMatricula] = useState(false);

  const verifyCallback = (recaptchaToken: string): void => {
    ////console.log(recaptchaToken);
    setLoadingCaptcha(false);
    setGoogleRecaptcha(recaptchaToken);
  };

  useEffect(() => {
    if (!googleRecaptcha) {
      setLoadingCaptcha(true);
    } else {
      setLoadingCaptcha(false);
    }
  }, [googleRecaptcha]);

  useEffect(() => {
    if (googleRecaptcha)
      setTimeout(() => {
        console.log("useEffect recaptcha");

        setGoogleRecaptcha(undefined);
        captcha?.execute();
      }, TWO_MINUTES);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [googleRecaptcha]);

  const history = useHistory();

  //async function submitLogin() {}

  async function handleLogin(tempUser?: string, tempPass?: string) {
    const data = {
      login: tempUser || usuario,
      password: tempPass || senha,
      "g-recaptcha-response": googleRecaptcha || "",
    };

    const options = {
      withCredentials: true,

      headers: {
        "content-type": "application/json",
        //'content-length': 89,
        "X-Forwarded-Host": X_FOWARD_HOST,
        Accept: "application/json",
      },
    };
    try {
      const response = await api.post("./admin/login", data, options);
      //console.log(response.data)
      ////console.log(response);

      if (response.data.success) {
        sessionStorage.setItem(
          `@${process.env.REACT_APP_ESTATE_ID}GESTAOUSERTOKEN`,
          response.data.token
        );
        setLoading(false);
        if (tempUser && tempUser) {
          history.push("admin/link");
        } else history.push("/admin");
      }
    } catch (error) {
      alert(
        "Não foi possivel fazer login\nUsuario/Senha incorreto(s) ou falta de conectividade com rede"
      );
      window.location.reload(false);

      //console.log(error)
      setLoading(false);
    }

    //if(response.data === 200 && response.dat)
  }

  async function handleLoginMatricula() {
    const data = {
      matricula: usuario,
      password: senha.toUpperCase(),
    };

    const url = process.env.REACT_APP_ATENDENTE_URL;
    const token = process.env.REACT_APP_ATENDENTE_TOKEN;
    const user = process.env.REACT_APP_ATENDENTE_LOGIN;
    const pass = process.env.REACT_APP_ATENDENTE_PASS;
    if (!url || !token || !user || !pass) {
      alert("Falha no login, tente outro metodo");
      return;
    }

    try {
      const response = await axios.post(url, data, {
        headers: {
          app: token,
        },
      });
      // console.log(response.data);

      if (response.data) {
        const rData = response.data;
        // console.log(rData);
        if (rData.user) {
          if (rData.user.EMPG_NOME_EMPREGADO) {
            sessionStorage.setItem(
              `@${process.env.REACT_APP_ESTATE_ID}TEMP_MATRICULA_NAME`,
              rData.user.EMPG_NOME_EMPREGADO
            );
            handleLogin(user, pass);
          }
        }
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      alert("Falha no login, verifique usuario e senha");
    }
  }

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();

    if (loading || loadingCaptcha) {
      return;
    }

    setLoading(true);

    if (usuario.length === 0 || senha.length === 0) {
      alert("Preencha ambos os campos");
      setLoading(false);

      return;
    }

    /*const data = {
			login: usuario,
			password: senha,
			'g-recaptcha-response': googleRecaptcha || '',
		};*/

    if (googleRecaptcha) {
      if (loginComMatricula) {
        handleLoginMatricula();
      } else handleLogin();
    } else {
      captcha?.execute();
      if (loginComMatricula) {
        handleLoginMatricula();
      } else handleLogin();
    }

    //api.post('/admin/login');

    //history.push('/admin');
  }

  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
  }, []);

  /*const x = '2021-05-24T11:05:48-03:00';

	console.log(moment(x).format('DD/MM/YYYY H:mm:ss'),'Moment');
	console.log(momentTZ.tz(x, 'America/Sao_Paulo').format('DD/MM/YYYY H:mm:ss'),'MomentTZ');

	const d = new Date(x);

	console.log(
		`${d.getDate()}/${d.getMonth()}/${d.getFullYear()} ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`
	);*/

  return (
    <div>
      <Recaptcha googleRecapt={!loadingCaptcha} />
      <ReCaptcha
        ref={(e) => {
          ////console.log(e);
          if (e) setCaptcha(e);
        }}
        sitekey={process.env.REACT_APP_RECAPTCHA as string}
        action="login"
        verifyCallback={verifyCallback}
      />
      <div className="container">
        <div style={{ flex: 1 }} className="row marginNone backgroundNone">
          <div className="col-md-6 offset-md-3  mt-5">
            <div className="" hidden={isReady}>
              <div className="">
                <div className="row  card-login">
                  <div className="col-md-5 p-2 float-xs-right text-center banner-login">
                    <div className="mt-5">
                      <img
                        className="align-middle mt-5"
                        src={pigzLogo}
                        alt="pigz-logo"
                      />
                    </div>
                    <div className=" mt-5">
                      <span className="orangelab-logo">
                        Um produto &nbsp;
                        <img
                          className="align-middle "
                          src={orangeLabLogo}
                          alt="orange-logo"
                        />
                      </span>
                    </div>
                  </div>
                  <div className="col-md-7 login-side  p-4">
                    <div className="text-left pb-2">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/${process.env.REACT_APP_FOLDER_IMAGE}/logo-colorida.svg`}
                        //src={'/build/images/logo-ame-colorida.svg'}
                        width="50%"
                        alt="logo"
                      />
                    </div>
                    <div>
                      <h2
                        className="title-login"
                        style={{ color: "#092A60", textAlign: "left" }}
                      >
                        {loginComMatricula ? "Login com matricula" : "Login"}
                      </h2>
                    </div>
                    <form id="formLogin" onSubmit={handleSubmit}>
                      <div className="form-group">
                        <div className="input-group mb-2">
                          <div className="input-group-prepend">
                            <div className="input-group-text">
                              <img src={iconUser} alt="logo" />
                            </div>
                          </div>
                          <input
                            className="form-control"
                            type="text"
                            name="login"
                            placeholder={
                              loginComMatricula ? "Matricula" : "Usuário"
                            }
                            value={usuario}
                            onChange={(event) => setUsuario(event.target.value)}
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="input-group mb-2">
                          <div className="input-group-prepend">
                            <div className="input-group-text">
                              <img src={iconLock} alt="logo" />
                            </div>
                          </div>
                          <input
                            className="form-control"
                            type="password"
                            name="password"
                            placeholder="Senha"
                            value={senha}
                            onChange={(event) => setSenha(event.target.value)}
                          />
                        </div>
                      </div>
                      <div className="form-group mt-2">
                        <button
                          type="submit"
                          className={`btn pl-4 pr-4  btn-primary ${
                            loadingCaptcha ? "btn-login-off" : "btn-login"
                          }`}
                        >
                          {loading ? (
                            <img
                              className="loadingImg"
                              src={loadingGif}
                              alt="loading"
                            />
                          ) : (
                            "Entrar"
                          )}
                        </button>
                      </div>
                      <p
                        style={{
                          font: "normal normal normal 18px/20px Roboto",
                          color: "#1069d9",
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setLoginComMatricula(!loginComMatricula);
                          setUsuario("");
                          setSenha("");
                        }}
                      >
                        {loginComMatricula
                          ? "Entrar como usuário"
                          : "Entrar como atendente"}{" "}
                      </p>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  //<Recaptcha googleRecapt={!loadingCaptcha}/>

  /*return (
		<div className='container'>
			<div className='row'>
				<div className='logoContainer'>
					<img src={pigzLogo} alt='pigzLogo' />
					<div className='logo-group'>
						<p className='logo-text'>Um produto </p>
						<img src={orangeLabLogo} alt='OrangeLogo' />
					</div>
				</div>
				<div className='login-form-container'>
					<div className='logoAme'>
						<img src='/build/images/logo-ame-colorida.svg' alt='LogoAme' />
					</div>
					<h1 className='login-title'>Login</h1>
					<form>
						<div className='login-input-container'>
							<img src={iconUser} alt='icon-user' />

							<input type='text' placeholder='Usuário' />
						</div>
						<div className='login-input-container'>
							<img src={iconLock} alt='icon-lock' />

							<input type='text' placeholder='Senha' />
						</div>
						<button className='login-submit-button' type='submit'>
							Entrar
						</button>
					</form>
				</div>
			</div>
		</div>
	);*/
}

export default Login;
